import { Grid } from '@mui/material';
import React from 'react';

export const SkillsProcedure = () => {
  
    return (
      <Grid>
      
      </Grid>
    );
  };
